module.exports = __webpack_public_path__ + "img/compact.0f00b2ea.png";